import { EFaxStatus } from '../../ui-model-types';
function getFaxCompletionStatus() {
  var faxIncompleteStatusesArray = [EFaxStatus.NeedsReview, EFaxStatus.NeedsSplitting, EFaxStatus.InProcess];
  var faxCompletedStatusesArray = [EFaxStatus.Approved, EFaxStatus.Archived, EFaxStatus.Rejected, EFaxStatus.Skipped, EFaxStatus.SplitCompleted, EFaxStatus.ReferralCreated];
  var faxIncompleteStatusesString = faxIncompleteStatusesArray.join(',');
  var faxCompletedStatusesString = faxCompletedStatusesArray.join(',');
  return {
    faxIncompleteStatusesArray: faxIncompleteStatusesArray,
    faxIncompleteStatusesString: faxIncompleteStatusesString,
    faxCompletedStatusesArray: faxCompletedStatusesArray,
    faxCompletedStatusesString: faxCompletedStatusesString
  };
}
export default getFaxCompletionStatus;